import { Pipe, PipeTransform } from '@angular/core';
import { htmlToText } from '../util';

@Pipe({ name: 'htmlToText', standalone: true })
export class HtmlToTextPipe implements PipeTransform {
    public transform(html: string | null | undefined): string {
        return htmlToText(html);
    }
}
